module.exports = __webpack_public_path__ + "img/hauptseite-willkommen.274879c6.jpg";